import { images } from "../../Constants/imageslinks";

function AndroidSection() {
  
  const handlePlayStoreClick = () => {
    window.open(
      "https://play.google.com/store/apps/details?id=life.minimis.launcher&hl=en",
      "_blank"
    );
  };

  return (
    <div className="bg-primary200">
      <div className="3xl:container 3xl:mx-auto">
        <div className="border-t-[1px] border-black lg:px-[11.66vw] md:px-8 px-4 3xl:px-[224px] lg:py-20 py-9 flex lg:items-center items-start lg:gap-20 gap-0 justify-between">
          <div className="flex flex-col lg:gap-6 gap-3">
            <p className="font-light md:text-[32px] text-2xl md:leading-[42px] leading-8 text-secondary100">
              Android User instead?
            </p>
            <p className="font-light text-base leading-6 text-secondary100">
              Check out our Android app on Google Play.
            </p>

            <div className="lg:flex flex-col gap-6 hidden">
              <div className="pt-4 pb-7 px-7 bg-white rounded-[10px] flex flex-col gap-3 w-full max-w-[544px] min-w-[350px]">
                <div className="flex justify-between items-center">
                  <img
                    src={images.playstoreIcon}
                    alt="playstore Icon"
                    className="max-w-[164px]"
                  />
                  <div className="flex xl:flex-row flex-col items-center gap-4">
                    <img
                      src={images.ratingstarImage}
                      alt="ratingstar Image"
                      className="max-w-[96px]"
                    />
                    <p className="font-normal text-base leading-[100%] text-secondary100/50">
                      -Constantijn
                    </p>
                  </div>
                </div>
                <p className="font-light text-base leading-6 text-center text-secondary200">
                  Minimis is the only minimalist launcher that has transformed
                  my phone habits.{" "}
                  <span className="font-medium">
                    {" "}
                    For the first time, I feel like I control my phone, not the
                    other way around.
                  </span>{" "}
                  The added friction layers between you and those "bad"
                  dopamine-stealing apps work brilliantly. You even feel guilty
                  thinking about opening one!{" "}
                  <span className="font-medium">
                    {" "}
                    Minimis has changed my life.
                  </span>{" "}
                  My focus strengthens daily, my baseline anxiety has dropped,
                  and I get more done. My brain feels better overall, like in
                  the "good old days" of the 90s, I feel calm. :)
                </p>
              </div>

              <img
                src={images.rating1}
                alt="rating image"
                className="w-full max-w-[544px]"
              />
              <img
                src={images.playstore}
                alt="playstore image"
                className="w-full max-w-[163px]"
                onClick={handlePlayStoreClick}
              />
            </div>
          </div>
          <img
            src={images.androidImage}
            alt="android launcher image"
            className="w-full max-w-[480px] lg:min-w-[300px] min-w-[150px]"
          />
        </div>
        <div className="flex flex-col gap-6 lg:hidden md:px-8 px-4 pb-9">
          <img
            src={images.rating_mobile}
            alt="rating image"
            className="w-full "
          />
          <div className="pt-4 pb-7 px-7 bg-white rounded-[10px] flex flex-col gap-3 w-full">
            <div className="flex justify-between items-center">
              <img
                src={images.playstoreIcon}
                alt="playstore Icon"
                className="max-w-[164px]"
              />
              <div className="flex lg:flex-row flex-col items-center gap-4">
                <img
                  src={images.ratingstarImage}
                  alt="ratingstar Image"
                  className="max-w-[96px]"
                />
                <p className="font-normal text-base leading-[100%] text-secondary100/50">
                  -Constantijn
                </p>
              </div>
            </div>
            <p className="font-light text-base leading-6 text-center text-secondary200">
              Minimis is the only minimalist launcher that has transformed my
              phone habits.{" "}
              <span className="font-medium">
                {" "}
                For the first time, I feel like I control my phone, not the
                other way around.
              </span>{" "}
              The added friction layers between you and those "bad"
              dopamine-stealing apps work brilliantly. You even feel guilty
              thinking about opening one!{" "}
              <span className="font-medium">
                {" "}
                Minimis has changed my life.
              </span>{" "}
              My focus strengthens daily, my baseline anxiety has dropped, and I
              get more done. My brain feels better overall, like in the "good
              old days" of the 90s, I feel calm. :)
            </p>
          </div>
          <img
            src={images.playstore}
            alt="playstore image"
            className="w-full max-w-[163px]"
            onClick={handlePlayStoreClick}
          />
        </div>
      </div>
    </div>
  );
}

export default AndroidSection;
